import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  VclAlertModule,
  VclAutocompleteModule,
  VclCardTemplateModule,
  VclDatepickerModule,
  VclFormFieldModule,
  VclInputModule,
  VclModalModule,
  VclSelectModule,
} from '@voxel/community';
import {
  VoxelCheckboxModule,
  VoxelFormFieldModule,
  VoxelInputModule,
  VoxelLinkModule,
  VoxelModalModule,
} from '@voxel/mobile';
import { LottieAnimationViewModule } from 'ng-lottie';

import { SharedModule } from '../../shared/shared.module';
import { AddressConfigTcComponent } from './address-config-tc/address-config-tc.component';
import { AdvisorCodeComponent } from './advisor-code/advisor-code.component';
import { CityOfficesSearchComponent } from './city-offices-search/city-offices-search.component';
import { ConfigurationIntroductionComponent } from './configuration-introduction/configuration-introduction.component';
import { ConfigurationRoutes } from './configuration.routes';
import { ConfirmPhoneComponent } from './confirm-phone/confirm-phone.component';
import { FourTaxWarningComponent } from './four-tax/four-tax-warning/four-tax-warning.component';
import { OpeningSavingsAccountComponent } from './opening-savings-account/opening-savings-account.component';
import { PayDayComponent } from './pay-day/pay-day.component';
import { ReceiveCardComponent } from './receive-card/receive-card.component';
import { RequestReceivedComponent } from './request-received/request-received.component';
import { CaptureRoutes } from '../capture/capture.routes';
import { DisbursementOfficeComponent } from './disbursement-office/disbursement-office.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    VclModalModule,
    VoxelLinkModule,
    VoxelModalModule,
    VoxelInputModule,
    VoxelCheckboxModule,
    VoxelFormFieldModule,
    VclAutocompleteModule,
    VclAlertModule,
    VclFormFieldModule,
    VclDatepickerModule,
    ConfigurationRoutes,
    LottieAnimationViewModule.forRoot(),
    ReactiveFormsModule,
    VclInputModule,
    VclCardTemplateModule,
    CaptureRoutes,
    VclSelectModule,
  ],
  providers: [],
  declarations: [
    ConfigurationIntroductionComponent,
    CityOfficesSearchComponent,
    ReceiveCardComponent,
    AddressConfigTcComponent,
    ConfirmPhoneComponent,
    FourTaxWarningComponent,
    OpeningSavingsAccountComponent,
    AdvisorCodeComponent,
    PayDayComponent,
    RequestReceivedComponent,
    DisbursementOfficeComponent,

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})

export class ConfigurationModule { }
